/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#deleteButton[_ngcontent-%COMP%]{background-color:#e0114d}"];
export { styles as styles };
